<app-show-img *ngIf="showImg && showImgUrl" [isVisible]="showImg" [showImgUrl]="showImgUrl" (isVisibleChange)="isVisibleImgChange($event)">
</app-show-img>
